export const showsArr = [];
export const faqData = [
  {
    id: 1,
    q: "FREQUENTLY ASKED QUESTIONS ABOUT THE COVID-19",
    answer: `
      <ul start="1">
        <li><strong>I am a tourist in Israel and I am concerned that I may have COVID-19, where should I go?</strong><br/>
           <ul>
               <li>
                  If you have a fever of 100.4F (38C) or higher, cough, trouble breathing, or other respiratory symptoms, you must immediately enter self-isolation and call the 101 MDA Emergency Services Hotline for medical advice.
                <strong>
                  Do not go to an HMO clinic or emergency ward.
                </strong>
         
               </li>
           </ul>
        </li>
        <!--<li><strong>When will Israel be open to incoming visitors again?</strong><br/>
           <ul>
               <li>
                At this moment there is not a known date in which Israel will be open to incoming visitors.
         
               </li>
           </ul>
        </li>-->
       
       
      </ul>
      `,
    isOpen: false,
  },
  {
    id: 2,
    q: "DO I NEED A VISA TO VISIT ISRAEL?",
    answer: `
      <p>We welcome visitors to Israel. Many countries have a Visa Waiver Program with Israel, which allows their citizens to visit Israel without a need for a visa. Before embarking on a trip, visitors desiring to stop in Israel on their way to other destinations must check if they need a pre-arranged tourist visa.</p>
      <p>Here is an updated list of countries from which tourists are required to present a prearranged visa: </p>
      <p><a href="https://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf" target="_blank" rel="noopener">www.mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>
      <p>All Visa Waiver Program travelers must present a machine-readable passport at the port of entry in order to enter Israel without a prearranged visa; otherwise, a visa is required. This applies to tourists arriving with a passage card from countries with a Waiver Program.</p>
      <p>Extending Your Stay ​</p>
      <p>Your visa can be extended (fee required) at the Ministry of the Interior office closest to you, please contact the ministry at <a href="tel:*3450">*3450</a> or dial <a href="tel:12223450">12223450</a> from a landline. If you’re calling from outside the country dial <a href="tel:+97226294666">+972-2-6294666</a></p>
      `,
    isOpen: false,
  },
  {
    id: 3,
    q: "ISN’T ISRAEL A LONG WAY AWAY?",
    answer: `
      
      <p>
      Not nearly as far as you may think: just 10 hours from New York (it’s quicker to fly from New York to Israel than from New York to Hawaii!), or 14 hours from Los Angeles. There are about ten nonstop flights a day from North America to Israel, on Air Canada, American Airlines/US Airways, Delta, El Al Israel Airlines and United. Plus you can connect to Israel through dozens of European cities.
      </p>
      .
      `,
    isOpen: false,
  },

  {
    id: 4,
    q: "WHAT DOCUMENTS DO I NEED TO TRAVEL TO ISRAEL?",
    answer: `
      
      <p>
       For U.S. and Canadian citizens, all you need is a passport that’s valid at least six months longer than your date of arrival in Israel. (For stays up to three months, you don’t need a visa.) If you’re not a U.S. or Canadian citizen, the same conditions apply to citizens of most western countries.
       </p>
      .
      `,
    isOpen: false,
  },

  {
    id: 5,
    q: "WHAT TO WEAR?",
    answer: `
      <p>
       Like almost everywhere in the world, casual is the "rule" for everyday sightseeing. Bring good walking shoes or sneakers and "layers." Israelis (especially women) like to be “elegant casual” on evenings in Tel Aviv and Jerusalem. Some religious shrines require modest dress (arms and legs covered, and, occasionally, no pants for women). Don't forget your swimsuit and, for the Dead Sea, plastic shoes or aqausox.
       </p>
      `,
    isOpen: false,
  },

  {
    id: 6,
    q: "TEMPERATURES",
    answer: `

        <p>Temperatures can vary widely so just pack for the "right" weather and you'll be fine. Seasons overlap of course, but general guidelines are:</p>
        <p>SUMMER (Jun/Jul/Aug/early Sep): Temperatures in the high 80º's, 90º's. Tel Aviv, and Tiberias will be hot and humid (like New York or Miami). Jerusalem is dryer and cooler, particularly at night. Masada and Eilat are extremely hot (110º+!)...but dry. There won't be a drop of rain.</p>

        <p>SHOULDERS (late Mar/Apr/May/late Sep/Oct/Nov): Daytime temperatures will be very pleasant: 75º-ish in most of the country (but hotter at the Red and Dead Seas). Jerusalem will be in the 70º's, 50º's in the evening. There'll be some rain - nothing torrential.</p>

        <p>WINTER (Dec/Jan/Feb/early Mar): Winter weather can fluctuate. Some winters are mild and sunny, some severe and overcast. There's often heavy rain and, in January and February, even snow sometimes. It'll probably be in the 50º's, 60º's most places, but in Jerusalem and the Galilee in the forties, and cold at night.</p>

      `,
    isOpen: false,
  },

  {
    id: 7,
    q: "I HEAR THERE IS A SECURITY INTERVIEW BEFORE MY FLIGHT…",
    answer: `
        <p>
        If you are flying EL AL Israel Airlines (or from Europe on Arkia Israel Airlines or Israir), please know that the security precautions taken by Israeli airlines are the stuff of legend and the envy of the world’s airlines. On check-in for your flights you will be asked a variety of questions during a security interview. Some of the questions may seem un-PC, intrusive, irrelevant or repetitive. Just answer truthfully, go with the flow and don’t lose your cool. Remember, the questions are designed to protect you and your fellow passengers. When you leave Israel, the departure process is identical to that outlined above for all airlines.
        </p>
      `,
    isOpen: false,
  },

  {
    id: 8,
    q: "Are working hours different?",
    answer: `
        
        <p>
           Yep, workdays are Sundays through Thursdays while the Weekend is Fridays and Saturdays. Most businesses are open on Fridays until the early afternoon, before the onset of the Jewish Shabbat, which begins at sundown on Friday and lasts until shortly after sundown on Saturday.  <a target="_blank" href="//www.timeanddate.com/worldclock/Israel">www.timeanddate.com/worldclock/Israel</a>
        </p>
      `,
    isOpen: false,
  },
];

export const faqDataForPage = [
  {
    id: 1,
    q: "FREQUENTLY ASKED QUESTIONS ABOUT THE COVID-19",
    answer: `
      <ol start="1">
        <li><strong>I am a tourist in Israel and I am concerned that I may have COVID-19, where should I go?</strong><br/>
           <ul>
               <li>
                  If you have a fever of 100.4F (38C) or higher, cough, trouble breathing, or other respiratory symptoms, you must immediately enter self-isolation and call the 101 MDA Emergency Services Hotline for medical advice.
                <strong>
                  Do not go to an HMO clinic or emergency ward.
                </strong>
         
               </li>
           </ul>
        </li>
        <li><strong>When will Israel be open to incoming visitors again?</strong><br/>
           <ul>
               <li>
                At this moment there is not a known date in which Israel will be open to incoming visitors.
         
               </li>
           </ul>
        </li>
       
       
      </ol>
      `,
    isOpen: false,
  },
  {
    id: 2,
    q: "DO I NEED A VISA TO VISIT ISRAEL?",
    answer: `
      <p>We welcome visitors to Israel. Many countries have a Visa Waiver Program with Israel, which allows their citizens to visit Israel without a need for a visa. Before embarking on a trip, visitors desiring to stop in Israel on their way to other destinations must check if they need a pre-arranged tourist visa.</p>
      <p>Here is an updated list of countries from which tourists are required to present a prearranged visa: </p>
      <p><a href="https://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf" target="_blank" rel="noopener">www.mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>
      <p>All Visa Waiver Program travelers must present a machine-readable passport at the port of entry in order to enter Israel without a prearranged visa; otherwise, a visa is required. This applies to tourists arriving with a passage card from countries with a Waiver Program.</p>
      <p>Extending Your Stay ​</p>
      <p>Your visa can be extended (fee required) at the Ministry of the Interior office closest to you, please contact the ministry at <a href="tel:*3450">*3450</a> or dial <a href="tel:12223450">12223450</a> from a landline. If you’re calling from outside the country dial <a href="tel:+97226294666">+972-2-6294666</a></p>
      `,
    isOpen: false,
  },
  {
    id: 3,
    q: "ISN’T ISRAEL A LONG WAY AWAY?",
    answer: `
      
      <p>
      Not nearly as far as you may think: just 10 hours from New York (it’s quicker to fly from New York to Israel than from New York to Hawaii!), or 14 hours from Los Angeles. There are about ten nonstop flights a day from North America to Israel, on Air Canada, American Airlines/US Airways, Delta, El Al Israel Airlines and United. Plus you can connect to Israel through dozens of European cities.
      </p>
 
      `,
    isOpen: false,
  },

  {
    id: 4,
    q: "WHAT DOCUMENTS DO I NEED TO TRAVEL TO ISRAEL?",
    answer: `
      
      <p>
       For U.S. and Canadian citizens, all you need is a passport that’s valid at least six months longer than your date of arrival in Israel. (For stays up to three months, you don’t need a visa.) If you’re not a U.S. or Canadian citizen, the same conditions apply to citizens of most western countries.
       </p>
    
      `,
    isOpen: false,
  },

  {
    id: 5,
    q: "IS IT SAFE TO TRAVEL TO ISRAEL?",
    answer: `
      
      <p>
       We wouldn’t urge you to come if it wasn’t. Every year between 3 and 4 million tourists vacation in Israel – and apart from those who fall in love with an Israeli – or with Israel – they all go home again safe and sound. The planes of 90+ airlines wouldn’t fly to Israel if it weren’t safe.
       </p>
      `,
    isOpen: false,
  },

  {
    id: 6,
    q: "I HEAR THERE IS A SECURITY INTERVIEW BEFORE MY FLIGHT…",
    answer: `
      <p>
      If you are flying EL AL Israel Airlines (or from Europe on Arkia Israel Airlines or Israir), please know that the security precautions taken by Israeli airlines are the stuff of legend and the envy of the world’s airlines. On check-in for your flights you will be asked a variety of questions during a security interview. Some of the questions may seem un-PC, intrusive, irrelevant or repetitive. Just answer truthfully, go with the flow and don’t lose your cool. Remember, the questions are designed to protect you and your fellow passengers. When you leave Israel, the departure process is identical to that outlined above for all airlines.
      </p>
      `,
    isOpen: false,
  },
  {
    id: 7,
    q: "WHAT IF I WANT TO VISIT ANOTHER ARAB COUNTRY?",
    answer: `
      <p>
      Go ahead. Like many European countries, Israel no longer stamps visitors’ passports, so your passport does not indicate that you were here.
      </p>
      `,
    isOpen: false,
  },
  {
    id: 8,
    q: "WHAT ABOUT HEALTH, MEDICINES, VACCINATIONS?",
    answer: `
      <p>
      Israel is an ultra-modern country with the world’s highest number of doctors per capita, and a health and hospital system that is the envy of the world. No vaccinations are required to visit Israel (unless you have recently been in an area where there have been epidemics of yellow fever, cholera or ebola). You can buy most standard over-the-counter equivalent of North American drugs in Israel. You can also bring supplies of your standard prescription drugs with you. (If you need to bring syringes and vials of medicine – bring along a letter from your doctor attesting to your needs, just in case.) If you need to see a doctor in Israel, check with your hotel concierge. Travel insurance (including medical coverage) is always recommended for all foreign travel.)
      </p>
      `,
    isOpen: false,
  },

  {
    id: 9,
    q: "WHAT TO WEAR?",
    answer: `
      <p>
       Like almost everywhere in the world, casual is the "rule" for everyday sightseeing. Bring good walking shoes or sneakers and "layers." Israelis (especially women) like to be “elegant casual” on evenings in Tel Aviv and Jerusalem. Some religious shrines require modest dress (arms and legs covered, and, occasionally, no pants for women). Don't forget your swimsuit and, for the Dead Sea, plastic shoes or aqausox.
       </p>
      `,
    isOpen: false,
  },
  {
    id: 10,
    q: "WHAT ABOUT MONEY?",
    answer: `
      <p>
       The Israeli currency is the Shekel (officially “New Israeli Shekel”), worth around 30 cents. On arrival in Israel, it’s a good idea to use your bank-card to withdraw some Shekels from the ATM in the arrival-halls at Ben Gurion - or change small amounts of dollars/or travelers’ checks at a bank or your hotel. There are ATM machines all over Israel and credit cards are widely accepted.
      </p>
      `,
    isOpen: false,
  },
  {
    id: 11,
    q: "ELECTRICITY",
    answer: `
      <p>
       Almost all hotel rooms are equipped with hairdryers, and all have shaver sockets. For other appliances, Israel's electricity is 220V A/C, single phase 50-cycles; 110V-220V transformers can be used. Israeli outlets have three prongs, but European two-prong adapters usually work. If you don’t have an adapter that seems to work, call the hotel’s front desk or visit a hardware store.
      </p>
      `,
    isOpen: false,
  },
  {
    id: 12,
    q: "KEEPING IN TOUCH",
    answer: `
      <p>
      Most hotels have free wi-fi in the lobby, and some hotels provide it free in the room. Many hotels also have Business Centers where you can access e-mail and the internet without charge. American cell-phones that work overseas will work in Israel too. Israel is 6 or 7 hours ahead of the East Coast of the USA depending on the season.
      </p>
      `,
    isOpen: false,
  },

  {
    id: 13,
    q: "TEMPERATURES",
    answer: `

        <p>Temperatures can vary widely so just pack for the "right" weather and you'll be fine. Seasons overlap of course, but general guidelines are:</p>
        <p>SUMMER (Jun/Jul/Aug/early Sep): Temperatures in the high 80º's, 90º's. Tel Aviv, and Tiberias will be hot and humid (like New York or Miami). Jerusalem is dryer and cooler, particularly at night. Masada and Eilat are extremely hot (110º+!)...but dry. There won't be a drop of rain.</p>

        <p>SHOULDERS (late Mar/Apr/May/late Sep/Oct/Nov): Daytime temperatures will be very pleasant: 75º-ish in most of the country (but hotter at the Red and Dead Seas). Jerusalem will be in the 70º's, 50º's in the evening. There'll be some rain - nothing torrential.</p>

        <p>WINTER (Dec/Jan/Feb/early Mar): Winter weather can fluctuate. Some winters are mild and sunny, some severe and overcast. There's often heavy rain and, in January and February, even snow sometimes. It'll probably be in the 50º's, 60º's most places, but in Jerusalem and the Galilee in the forties, and cold at night.</p>

      `,
    isOpen: false,
  },

  {
    id: 14,
    q: "GETTING AROUND",
    answer: `
        <p><strong>BUS:</strong> Israel has one of the world’s best and most inexpensive bus systems, with almost every city, town, village and settlement connected to the system.</p>
 
        <p><strong>TRAIN:</strong> High speed trains link Ben Gurion Airport with Tel Aviv, Jerusalem and Haifa, and there are fast and, efficient and inexpensive train service throughout much of the country.  Rail travel is inexpensive and very easy to navigate.</p>
         
        <p><strong>FLIGHTS:</strong> Tel Aviv and Eilat are connected by multiple flights daily aboard Arkia, El Al and Israir, and there are also flights to Haifa and the Galilee.</p>
         
        <p><strong>TAXIS:</strong> There are taxis available in the cities, and taxi drivers are also happy to take you between cities. Check the price before you start your journey.</p>
         
        <p><strong>SHARED TAXIS:</strong> Shared taxis or “Sherut” are very popular. There are “Sherut” stations throughout the cities. Ask at your hotel for the nearest Sherut stand.</p>
         
        <p><strong>CAR RENTAL:</strong>
        Most international car rental groups have offices in Israel – and there are excellent Israeli car rental firms too. Your American or Canadian drivers’ license is valid in Israel.</p>
             
      `,
    isOpen: false,
  },
];

export const newPosts = [
  {
    title: "Catholic 7 Day Itinerary",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/catholic7dayitinerary.jpg",
    side_img: "/PostCarousel/Itineraries/catholic7dayitinerary.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Catholic-7_Day_Itinerary",
  },
  {
    title: "Youth Itinerary - 7 Day Tour",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/youthitinerary7daytour.jpg",
    side_img: "/PostCarousel/Itineraries/youthitinerary7daytour.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Youth_Itinerary_7_Day_Tour",
  },
  {
    title: "First Timers - 7 Day Tour",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/firsttimers7daytour.jpg",
    side_img: "/PostCarousel/Itineraries/firsttimers7daytour.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "First_Timers_7_Day_Tour",
  },
  {
    title: "Christian Interest Itinerary - 10 Days Tour",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/christianinterestitineraries10daystour.jpg",
    side_img:
      "/PostCarousel/Itineraries/christianinterestitineraries10daystour.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Christian_Interest_Itinerary_10_Days_Tour",
  },
  {
    title: "A Christian Adventure Itinerary",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/eilattojerusalemin10days.jpg",
    side_img: "/PostCarousel/Itineraries/eilattojerusalemin10days.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Eilat_To_Jerusalem_In_10_Days",
  },
  {
    title: "Evangelical Christian Itineraries - 10 Day Tour",
    sml_desc: "",
    desc: "",
    img:
      "/PostCarousel/Itineraries/evangelicalchristianitineraries10daytour.jpg",
    side_img:
      "/PostCarousel/Itineraries/evangelicalchristianitineraries10daytour.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Evangelical_Christian_Itineraries_10_Day_Tour",
  },
  {
    title: "Catholic Interest Itineraries - 10 Days Tour",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/catholicinterestitineraries10daystour.jpg",
    side_img:
      "/PostCarousel/Itineraries/catholicinterestitineraries10daystour.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Catholic_Interest_Itineraries_10_Days_Tour",
  },
  {
    title: "Women in the Old and New Testament",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Itineraries/womenintheoldandnewtestament.jpg",
    side_img: "/PostCarousel/Itineraries/womenintheoldandnewtestament.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "itineraries",
    id: "Women_In_The_Old_And_New_Testament",
  },
  {
    title: "MOUNT CARMEL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/CoastalPlain/mountcarmel.jpg",
    side_img: "/PostCarousel/CoastalPlain/mountcarmel.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "coastalPlain",
    id: "Mount_Carmel",
  },
  {
    title: "Haifa",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/CoastalPlain/haifa.jpg",
    side_img: "/PostCarousel/CoastalPlain/haifa.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "3ahATaKkhBk",
    forVidPage: false,
    isDouble: false,
    ctg: "coastalPlain",
    id: "Haifa",
  },
  {
    title: "AKKO",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/CoastalPlain/akko.jpg",
    side_img: "/PostCarousel/CoastalPlain/akko.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "KlXXyToCmCM",
    forVidPage: false,
    isDouble: false,
    ctg: "coastalPlain",
    id: "Akko",
  },
  {
    title: "CAESAREA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/CoastalPlain/caesarea.jpg",
    side_img: "/PostCarousel/CoastalPlain/caesarea.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "eLZ433_S6HI",
    forVidPage: false,
    isDouble: false,
    ctg: "coastalPlain",
    id: "Caesarea",
  },
  {
    title: "JAFFA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/CoastalPlain/jaffa.jpg",
    side_img: "/PostCarousel/CoastalPlain/jaffa.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "tgF0zMUYY2g",
    forVidPage: false,
    isDouble: false,
    ctg: "coastalPlain",
    id: "Jaffa",
  },
  {
    title: "SEA OF GALILEE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/seaofgalilee.jpg",
    side_img: "/PostCarousel/galilee/seaofgalilee.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "haG-t3wwuMc",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Sea_Of_Galilee",
  },
  {
    title: "MEGIDDO",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/megiddo.jpg",
    side_img: "/PostCarousel/galilee/megiddo.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Megiddo",
  },
  {
    title: "CAESAREA PHILIPPI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/caesareaphilippi.jpg",
    side_img: "/PostCarousel/galilee/caesareaphilippi.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "5Ep3GgxELag",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Caesarea_Philippi",
  },
  {
    title: "CANA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/cana.jpg",
    side_img: "/PostCarousel/galilee/cana.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Cana",
  },
  {
    title: "CAPERNAUM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/capernaum.jpg",
    side_img: "/PostCarousel/galilee/capernaum.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Caper_Naum",
  },
  {
    title: "MAGDALA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/magdala.jpg",
    side_img: "/PostCarousel/galilee/magdala.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Magdala",
  },
  {
    title: "MOUNT OF BEATITUDES",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/mountofbeatitudes.jpg",
    side_img: "/PostCarousel/galilee/mountofbeatitudes.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Mount_Of_Beatitudes",
  },
  {
    title: "MOUNT TABOR",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/mounttabor.jpg",
    side_img: "/PostCarousel/galilee/mounttabor.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Mount_Tabor",
  },
  {
    title: "NAZARETH",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/nazareth.jpg",
    side_img: "/PostCarousel/galilee/nazareth.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "1M7N5BcmjFM",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Nazareth",
  },
  {
    title: "JESUS BOAT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/jesusboat.jpg",
    side_img: "/PostCarousel/galilee/jesusboat.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Jesus_Boat",
  },
  {
    title: "TIBERIAS",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/tiberias.jpg",
    side_img: "/PostCarousel/galilee/tiberias.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Tiberias",
  },
  {
    title: "YARDENIT",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/yardenit.jpg",
    side_img: "/PostCarousel/galilee/yardenit.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Yardenit",
  },

  {
    title: "TABGHA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/tabgha.jpg",
    side_img: "/PostCarousel/galilee/tabgha.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Tabgha",
  },
  {
    title: "THE GOSPEL TRAIL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/thegospeltrail.jpg",
    side_img: "/PostCarousel/galilee/thegospeltrail.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "THE_GOSPEL_TRAIL",
  },
  {
    title: "ZIPPORI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/zippori.jpg",
    side_img: "/PostCarousel/galilee/zippori.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Zippori",
  },
  {
    title: "KURSI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/galilee/kursi.jpg",
    side_img: "/PostCarousel/galilee/kursi.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "galilee",
    id: "Kursi",
  },
  {
    title: "Mount Zion",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/churchofthedormitiondavidstombupperroom.jpg",
    side_img:
      "/PostCarousel/jerusalem/churchofthedormitiondavidstombupperroom.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Mount_Zion_Church_of_the_Dormition_Davids_Tomb_Upper_Room",
  },
  {
    title: "CHURCH OF THE HOLY SEPULCHRE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/churchoftheholysepulchre.jpg",
    side_img: "/PostCarousel/jerusalem/churchoftheholysepulchre.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Church_Of_The_Holy_Sepulchre",
  },
  {
    title: "DAVIDSON CENTER",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/davidsoncenter.jpg",
    side_img: "/PostCarousel/jerusalem/davidsoncenter.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Davidson_Center",
  },
  {
    title: "WESTERN WALL",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/westernwall.jpg",
    side_img: "/PostCarousel/jerusalem/westernwall.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Western_Wall",
  },
  {
    title: "CITY OF DAVID",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/cityofdavid.jpg",
    side_img: "/PostCarousel/jerusalem/cityofdavid.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "City_Of_David",
  },
  {
    title: "POOL OF SILOAM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/poolofsiloam.jpg",
    side_img: "/PostCarousel/jerusalem/.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Pool_Of_Siloam",
  },
  {
    title: "ZEDEKIAH’S CAVE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/zedekiahscave.jpg",
    side_img: "/PostCarousel/jerusalem/zedekiahscave.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Zedekiahs_Cave",
  },
  {
    title: "MOUNT OF OLIVES",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/mountofolives.jpg",
    side_img: "/PostCarousel/jerusalem/mountofolives.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Mount_Of_Olives",
  },
  {
    title: "GARDEN OF GETHSEMANE",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/gardenofgethsemane.jpg",
    side_img: "/PostCarousel/jerusalem/gardenofgethsemane.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Garden_Of_Gethsemane",
  },
  {
    title: "VIA DOLOROSA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/viadolorosa.jpg",
    side_img: "/PostCarousel/jerusalem/viadolorosa.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Via_Dolorosa",
  },
  {
    title: "GATES OF JERUSALEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/gatesofjerusalem.jpg",
    side_img: "/PostCarousel/jerusalem/gatesofjerusalem.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Gates_Of_Jerusalem",
  },
  {
    title: "GARDEN TOMB",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/gardentomb.jpg",
    side_img: "/PostCarousel/jerusalem/gardentomb.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Garden_Tomb",
  },
  {
    title: "YAD VASHEM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/yadvashem.jpg",
    side_img: "/PostCarousel/jerusalem/yadvashem.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Yad_Vashem",
  },
  {
    title: "EIN KAREM",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/einkarem.jpg",
    side_img: "/PostCarousel/jerusalem/einkarem.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Ein_Karem",
  },
  {
    title: "ELAH VALLEY",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/jerusalem/elahvalley.jpg",
    side_img: "/PostCarousel/jerusalem/elahvalley.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "jerusalem",
    id: "Elah_Valley",
  },
  {
    title: "Qasr Al-Yahud",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/valleydesert/qasralyahud.jpg",
    side_img: "/PostCarousel/valleydesert/qasralyahud.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "valleyDesert",
    id: "Qasr_Al_Yahud",
  },
  {
    title: "Qumran",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/valleydesert/qumran.jpg",
    side_img: "/PostCarousel/valleydesert/qumran.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "valleyDesert",
    id: "Qumran",
  },
  {
    title: "EIN GEDI",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/valleydesert/eingedi.jpg",
    side_img: "/PostCarousel/valleydesert/eingedi.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "",
    forVidPage: false,
    isDouble: false,
    ctg: "valleyDesert",
    id: "Ein_Gedi",
  },
  {
    title: "MASADA",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/valleydesert/masada.jpg",
    side_img: "/PostCarousel/valleydesert/masada.jpg",
    read_more: "READ MORE",
    isVid: false,
    vidId: "XxWa_MNm5x8",
    forVidPage: false,
    isDouble: false,
    ctg: "valleyDesert",
    id: "Masada",
  },
];

export const newVideos = [
  {
    title: "Choco de Jesus",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Testimonials/chocodejesus.jpg",
    img_mob: "/PostCarousel/Testimonials/chocodejesus.jpg",
    side_img: "/PostCarousel/Testimonials/chocodejesus.jpg",
    read_more: "READ MORE",
    isVid: true,
    vidId: "ubargPBAlbY",
    forVidPage: true,
    ctg: "testimonials",
    id: "Choco_De_Jesus",
  },

  {
    title: "Archbishop Collins",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Testimonials/archbishopcollins.jpg",
    img_mob: "/PostCarousel/Testimonials/archbishopcollins.jpg",
    side_img: "/PostCarousel/Testimonials/archbishopcollins.jpg",
    read_more: "READ MORE",
    isVid: true,
    vidId: "aDlE4i7Br48",
    forVidPage: true,
    ctg: "testimonials",
    id: "Archbishop_Collins",
  },

  {
    title: "Archbishop Prendergast",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Testimonials/archbishopprendergast.jpg",
    img_mob: "/PostCarousel/Testimonials/archbishopprendergast.jpg",
    side_img: "/PostCarousel/Testimonials/archbishopprendergast.jpg",
    read_more: "READ MORE",
    isVid: true,
    vidId: "O0ibUMZQNnw",
    forVidPage: true,
    ctg: "testimonials",
    id: "Archbishop_Prendergast",
  },
];

export const TouristInfoPosts = [
  {
    title: "What To Pack",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/what-to-pack.jpg",
    side_img: "/PostCarousel/what-to-pack.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-what-to-pack",
    isVid: false,
    ctg: "TouristInfo",
    id: "What_To_Pack",
  },
  // This post had moved to the Passport post/ ASked by HADAR 18.05.2020
  //  {
  //  "title":"Immigration Customs",
  //  "sml_desc":"",
  //  "desc":"",
  //  "img":"/PostCarousel/immigration-customs.jpg",
  //  "side_img":"/PostCarousel/immigration-customs.jpg",
  //  "read_more":"READ MORE",
  //  "link": "/Posts/index.php?post=20",
  //  "css_class":"unic-post-immigration-customs",
  //  "isVid" : false,
  //  "ctg"   : 'TouristInfo',
  //   "id"    : 'Immigration_Customs'
  // },
  // END This post had moved to the Passport post/ ASked by HADAR 18.05.2020

  {
    title: "Weather",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/weather.jpg",
    side_img: "/PostCarousel/weather.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-weather",
    isVid: false,
    ctg: "TouristInfo",
    id: "Weather",
  },
  {
    title: "Transportation",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/transportation.jpg",
    side_img: "/PostCarousel/transportation.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-transportation",
    isVid: false,
    ctg: "TouristInfo",
    id: "Transportation",
  },
  {
    title: "Frequently Asked Questions",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/faq.jpg",
    side_img: "/PostCarousel/faq.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-faq",
    isVid: false,
    ctg: "TouristInfo",
    id: "Frequently_Asked_Questions",
  },

  {
    title: "Israeli Currency",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/israeli-currency.jpg",
    side_img: "/PostCarousel/israeli-currency.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-israeli-currency",
    isVid: false,
    ctg: "TouristInfo",
    id: "Israeli_Currency",
  },
  {
    title: "Electrical Appliances",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/electrical-appliances.jpg",
    side_img: "/PostCarousel/electrical-appliances.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-electrical-appliances",
    isVid: false,
    ctg: "TouristInfo",
    id: "Electrical_Appliances",
  },
  {
    title: "Passports Visa",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/Passports-visa.jpg",
    side_img: "/PostCarousel/Passports-visa.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-Passports-visa",
    isVid: false,
    ctg: "TouristInfo",
    id: "Passports_Visa",
  },
  {
    title: "A Destination for All",
    sml_desc: "",
    desc: "",
    img: "/PostCarousel/PlanYourTrip/destination-for-all.jpg",
    side_img: "/PostCarousel/PlanYourTrip/destination-for-all.jpg",
    read_more: "READ MORE",
    link: "/Posts/index.php?post=20",
    css_class: "unic-post-Passports-visa",
    isVid: false,
    ctg: "TouristInfo",
    id: "Destination_For_All",
  },
];

export const Reminders = [
  // Tel Aviv
  {
    quote: "One of the world's 25 best cities for foodies",
    site: "Business Insider",
    img: "/References/1.jpg",
    ctg: "Tel Aviv",
  },

  // Jerusalem
  {
    quote: "TripAdvisor Traveler's Choice Award 2015",
    site: "TripAdvisor",
    img: "/References/9.jpg",
    ctg: "Jerusalem",
  },

  {
    quote: "One of the world's leading party cities",
    site: "Telegraph",
    img: "/References/2.jpg",
    ctg: "Tel Aviv",
  },

  {
    quote: "One of the cities with most beautiful people",
    site: "Conde Nast",
    img: "/References/3.jpg",
    ctg: "Tel Aviv",
  },

  {
    quote: "One of the 20 must visit destinations in the world  TNS",
    site: "The National Student",
    img: "/References/10.jpg",
    ctg: "Jerusalem",
  },

  {
    quote: "One of the best beach party spots on the planet",
    site: "USA Today",
    img: "/References/4.jpg",
    ctg: "Tel Aviv",
  },
  {
    quote: "One of the world's top 10 beach cities",
    site: "National Geographic",
    img: "/References/5.jpg",
    ctg: "Tel Aviv",
  },

  {
    quote: "3rd Of 6 Top world’s holiest sites",
    site: "National Geographic",
    img: "/References/11.jpg",
    ctg: "Jerusalem",
  },

  {
    quote: "One of the world's top ten cities",
    site: "Lonely Planet",
    img: "/References/6.jpg",
    ctg: "Tel Aviv",
  },
  {
    quote: "One of the world's top ten hedonistic city breaks ",
    site: "Lonely Planet",
    img: "/References/7.jpg",
    ctg: "Tel Aviv",
  },
  {
    quote:
      "I just thought it was magical… It instantly turned into my favorite trip.",
    site: "TripAdvisor",
    img: "/References/12.jpg",
    ctg: "Jerusalem",
    job: "CEO, Stephen Kaufer about Jerusalem",
    cssClass: "make-it-smller",
  },

  {
    quote: "The World’s New Dining Hotspot",
    site: "Bloomberg.com",
    img: "/References/8.jpg",
    ctg: "Tel Aviv",
  },
];



// WEBPACK FOOTER //
// ./src/Data/Data.js